import React from 'react'
import Dashboard from './post/Dashboard'
import BookNewRide from './post/BookNewRide'
import UpcomingRide from './post/UpcomingRide'
import CompleteRide from './post/CompleteRide'
import CancelRide from './post/CancelRide'
import Profile from './post/Profile'
import ChangePassword from './post/ChangePassword'
import AddTrip from './post/AddTrip'
import Earning from './component/Earning'
import Notification from './component/Notification'

const routes = [
    { path: '/dashboard', name: 'Dashboard', element: Dashboard },

    { path: '/ongoing-ride', name: 'new-ride', element: BookNewRide },
    { path: '/upcoming-ride', name: 'upcoming-ride', element: UpcomingRide },
    { path: '/complete-ride', name: 'complete-ride', element: CompleteRide },
    { path: '/declined-ride', name: 'cancel-ride', element: CancelRide },
    { path: '/profile', name: 'profile', element:Profile },
    { path: '/change-password', name: 'profile', element:ChangePassword },
    { path: '/add-trip', name: 'add-trip', element:AddTrip },
    { path: '/my-earning', name: 'earning', element:Earning },
    { path: '/notification', name: 'notification', element:Notification },
]

export default routes